import {Component, OnInit} from "@angular/core";

@Component({
  selector: 'contact-user',
  templateUrl: './contact-user.component.html',
  styleUrls: ['./contact-user.component.css']
})

export class ContactUser implements OnInit {

  constructor() {
    }

    //showMaxAttachmentsExceeded() {
    //    this.service.showError("You must be premium user to add more than 2 attachments")
    //}

  ngOnInit() {

  }

}
